<template>
    <TransitionFade>
        <div class="account-notification" v-if="isPopupOpen">
            <span class="account-notification__close" @click="closePopup"></span>
            <WebpImage
                class="account-notification__logo"
                src="/frontend/kasa-loyalty/img/static/logo.svg"
                alt="Sazka logo"
                width="82"
                height="82"
            />
            <InfoText :title="title" :perex="perex" class="account-notification__info-text" />
            <a class="account-notification__button btn btn-secondary" :href="settings.url.profile" v-html="buttonText">
            </a>
        </div>
    </TransitionFade>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { cookieStore } from "@/shared/utils/store/use-store";
import InfoText from "./shared/info-text.vue";
import { userNotificationState } from "../use-user-account";
import { settings } from "@/settings";
import { isMobileApp } from "@/mobile-apps/mobile-app-integration";

const cookieName = "account-notification-closed";
const cookieDuration = 14; // 14 days

const temporarilyClosed = ref(false);

const closePopup = () => {
    temporarilyClosed.value = true;
    cookieStore.set(cookieName, "true", { expires: cookieDuration });
};

const canOpen = computed(() => userNotificationState.value != "None");

const isPopupOpen = computed(
    () =>
        !isMobileApp &&
        canOpen.value &&
        window.location.pathname != settings.url.profile &&
        !cookieStore.get<boolean>(cookieName) &&
        !temporarilyClosed.value
);

const title = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Potřebujeme ještě pár údajů";
        case "VerifyEmail":
            return "Ověřit emailovou adresu";

        default:
            return "";
    }
});
const perex = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Nenechte si uniknout žádnou zajímavou nabídku a získejte možnost využít veškeré odměny i bonusy na maximum.";
        case "VerifyEmail":
            return "Ověřte si e-mail, aby vám už neunikla žádná zajímavá nabídka, odměna ani bonus.";

        default:
            return "";
    }
});
const buttonText = computed(() => {
    switch (userNotificationState.value) {
        case "FillInfo":
            return "Doplnit údaje";
        case "VerifyEmail":
            return "Ověřit email";

        default:
            return "";
    }
});
</script>
